import BugReportIcon from "@mui/icons-material/BugReport";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 260;

export interface NavItem {
  path: string;
  i18nKey: string;
  icon: SvgIconComponent;
}

export const NAV_ITEMS: NavItem[] = [
  {
    path: "/",
    i18nKey: "nav.home",
    icon: BugReportIcon,
  },
];
